interface TimeRange {
    start: number;
    end: number;
}

// const limits: Record<string, TimeRange> = {
//     us: {
//         start: new Date('2025/04/08 15:00:00 GMT+8').getTime(),
//         end: new Date('2025/06/08 15:00:00 GMT+8').getTime(),
//     },
//     ca: {
//         start: new Date('2025/04/08 15:00:00 GMT+8').getTime(),
//         end: new Date('2025/06/08 15:00:00 GMT+8').getTime(),
//     },
//     au: {
//         start: new Date('2025/04/07 15:00:00 GMT+8').getTime(),
//         end: new Date('2025/06/07 15:00:00 GMT+8').getTime(),
//     },
//     za: {
//         start: new Date('2025/04/15 15:00:00 GMT+8').getTime(),
//         end: new Date('2025/06/15 15:00:00 GMT+8').getTime(),
//     },
//     de: {
//         start: new Date('2025/04/15 15:00:00 GMT+8').getTime(),
//         end: new Date('2025/06/15 15:00:00 GMT+8').getTime(),
//     },
//     fr: {
//         start: new Date('2025/04/15 15:00:00 GMT+8').getTime(),
//         end: new Date('2025/06/15 15:00:00 GMT+8').getTime(),
//     },
//     es: {
//         start: new Date('2025/04/15 15:00:00 GMT+8').getTime(),
//         end: new Date('2025/06/15 15:00:00 GMT+8').getTime(),
//     },
//     it: {
//         start: new Date('2025/04/15 15:00:00 GMT+8').getTime(),
//         end: new Date('2025/06/15 15:00:00 GMT+8').getTime(),
//     },
//     eu: {
//         start: new Date('2025/04/15 15:00:00 GMT+8').getTime(),
//         end: new Date('2025/06/15 15:00:00 GMT+8').getTime(),
//     },
//     uk: {
//         start: new Date('2025/04/15 15:00:00 GMT+8').getTime(),
//         end: new Date('2025/06/15 15:00:00 GMT+8').getTime(),
//     },
//     jp: {
//         start: new Date('2025/04/15 15:00:00 GMT+8').getTime(),
//         end: new Date('2025/06/15 15:00:00 GMT+8').getTime(),
//     },
//     kr: {
//         start: new Date('2025/04/10 15:00:00 GMT+8').getTime(),
//         end: new Date('2025/06/10 15:00:00 GMT+8').getTime(),
//     },
// };

const limits: Record<string, TimeRange> = {
    us: {
        start: new Date('2025/04/15 15:00:00 GMT+8').getTime(),
        end: new Date('2025/04/30 21:59:00 GMT+8').getTime(),
    },
    ca: {
        start: new Date('2025/04/15 15:00:00 GMT+8').getTime(),
        end: new Date('2025/04/30 21:59:00 GMT+8').getTime(),
    },
    au: {
        start: new Date('2025/04/15 15:00:00 GMT+8').getTime(),
        end: new Date('2025/04/30 21:59:00 GMT+8').getTime(),
    },
    za: {
        start: new Date('2025/04/15 15:00:00 GMT+8').getTime(),
        end: new Date('2025/05/08 15:00:00 GMT+8').getTime(),
    },
    de: {
        start: new Date('2025/04/15 15:00:00 GMT+8').getTime(),
        end: new Date('2025/05/08 15:00:00 GMT+8').getTime(),
    },
    fr: {
        start: new Date('2025/04/15 15:00:00 GMT+8').getTime(),
        end: new Date('2025/05/08 15:00:00 GMT+8').getTime(),
    },
    es: {
        start: new Date('2025/04/15 15:00:00 GMT+8').getTime(),
        end: new Date('2025/05/08 15:00:00 GMT+8').getTime(),
    },
    it: {
        start: new Date('2025/04/15 15:00:00 GMT+8').getTime(),
        end: new Date('2025/05/08 15:00:00 GMT+8').getTime(),
    },
    eu: {
        start: new Date('2025/04/15 15:00:00 GMT+8').getTime(),
        end: new Date('2025/05/08 15:00:00 GMT+8').getTime(),
    },
    uk: {
        start: new Date('2025/04/15 15:00:00 GMT+8').getTime(),
        end: new Date('2025/05/08 15:00:00 GMT+8').getTime(),
    },
    jp: {
        start: new Date('2025/04/15 15:00:00 GMT+8').getTime(),
        end: new Date('2025/05/08 15:00:00 GMT+8').getTime(),
    },
    kr: {
        start: new Date('2025/04/15 15:00:00 GMT+8').getTime(),
        end: new Date('2025/05/08 15:00:00 GMT+8').getTime(),
    },
};

/**
 * @param return -1: not in festival, 0: in festival, 1: overda
 */
export const isMembersFestival = (locale: string): -1 | 0 | 1 => {
    const now = new Date().getTime();
    if (limits[locale]) {
        if (now < limits[locale].start) return -1;
        if (now >= limits[locale].start && now <= limits[locale].end) return 0;
        if (now > limits[locale].end) return 1;
    }

    return -1;
};
